import { motion } from "framer-motion";
import { GraduationCap, TrendingUp, Wrench, BadgeCheck } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];
const IMG = "https://images.unsplash.com/photo-1601655781320-205e34c94eb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBtYWxlJTIwdGVhY2hlciUyMHByb2Zlc3Npb25hbGVufDB8fHx8MTc4NTY2MzUyNnww&ixlib=rb-4.1.0&q=85";

const CREDS = [
  { icon: Wrench, title: "Diploma · Mechanical Engineering", desc: "Hands-on workshop foundation — the practical core." },
  { icon: GraduationCap, title: "B.E. · Mechanical Engineering", desc: "Full degree depth across thermo, SOM, design and manufacturing." },
  { icon: BadgeCheck, title: "MBA · Finance", desc: "Postgraduate command of corporate finance and markets." },
  { icon: TrendingUp, title: "Active Trader", desc: "Trades the same technical framework he teaches." },
];

export const About = () => (
  <section id="mentor" className="border-t border-white/10 px-6 py-24 md:px-12 md:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 lg:grid-cols-12">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="lg:col-span-5"
      >
        <div className="overflow-hidden border border-white/10">
          <img src={IMG} alt="Founder and lead mentor of PP Academy" className="aspect-[4/5] w-full object-cover grayscale-[20%]" />
        </div>
        <p className="mt-6 font-editorial text-xl italic leading-relaxed text-zinc-400 md:text-2xl">
          "I teach every subject the way I wish someone had taught me — from first principles, without the fear."
        </p>
      </motion.div>
      <div className="lg:col-span-7">
        <p className="mb-4 text-xs font-medium uppercase tracking-[0.4em] text-brand">The Mentor</p>
        <h2 className="font-display text-4xl font-black uppercase leading-none tracking-tighter sm:text-5xl lg:text-6xl">
          One teacher<span className="text-brand">.</span>
          <br />
          <span className="font-light text-zinc-500">Every stage of your journey.</span>
        </h2>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
          From a class-3 multiplication table to a postgraduate DCF valuation — PP Academy is built on one
          unusual combination: a mechanical engineer who holds an MBA in Finance and actively trades the
          markets. Teaching experience across boards and universities ties it all together.
        </p>
        <div className="mt-14 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
          {CREDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.6, ease: EASE }}
              className="bg-[#0a0a0a] p-8"
              data-testid={`credential-${i}`}
            >
              <c.icon size={22} className="text-brand" />
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight">{c.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-zinc-500">{c.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
